import axios from 'axios';

export default axios.create({
  baseURL: 'https://secure.webbookingpro.com/api/booking.php', //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
